import React,{ Component } from "react";
//import { Container } from "react-bootstrap";
import Header from './Header';
import About from './About'
import Navigation from "./Navbar";
import Projects from "./Projects";
import Player from "./Player";
import Contact from './Contact';

class Main extends Component{
    render(){
      return (   
      <div>
      <Header/>
      <Navigation/>
      <About/>
      <Projects/>
      <Player/>
      <Contact/>
     
      </div>
    );
  
    }
  } 
  export default Main;
